import PropTypes from "prop-types";
import { ChevronDown, ChevronUp } from "react-ikonate";
import styles from "./OrderControls.module.css";

/**
 * Interactive component. Provides controls for reordering categories.
 */
export function OrderControls({ isFirst, isLast, onPrevious, onNext }) {
  return (
    <div className={styles.container}>
      <button
        className={styles.button}
        disabled={isFirst}
        title="move category up"
        onClick={(e) => {
          e.preventDefault();
          onPrevious();
        }}
      >
        <ChevronUp className={styles.icon} />
      </button>
      <button
        className={styles.button}
        disabled={isLast}
        title="move category down"
        onClick={(e) => {
          e.preventDefault();
          onNext();
        }}
      >
        <ChevronDown className={styles.icon} />
      </button>
    </div>
  );
}

OrderControls.propTypes = {
  /**
   * Set to true to disable 'previous' button.
   */
  isFirst: PropTypes.bool,

  /**
   * Set to true to disable 'next' button.
   */
  isLast: PropTypes.bool,

  /**
   * Called when the 'previous' button is clicked.
   */
  onPrevious: PropTypes.func.isRequired,

  /**
   * Called when the 'next' button is clicked.
   */
  onNext: PropTypes.func.isRequired,
};
